import { MealSize } from '../../src/ts/@types/generated/graphql/catalog-service/graphql';

export const DEFAULT_TENANT_ELIGIBILITY_CONFIG_LOGICAL_ID = 'DEFAULT';

/**
 * Regex patterns for input validation
 */

export const RegexPatterns = {
  EMAIL_REGEX:
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  CONTACT_NUMBER_REGEX: /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
  CONTACT_NUMBER_INTL_CODE_REGEX: /^[^1+]/,
  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W])(?=.{6,})/,
  IS_BIGGER_THAN_SIX_CHARS: /^(?=.{6,})/,
  HAS_UPPERCASE_LETTER: /^(?=.*[A-Z])/,
  HAS_NUMBER: /^(?=.*[0-9])/,
  HAS_SPECIAL_CHAR: /^(?=.*[\W])/,
  ZIP_CODE: /^\d{5}([-]?\d{4})?$/,
};

export const SubMgmtLinks = {
  DELIVERY_ADDRESS: 'delivery-address',
  PAYMENT_METHOD: 'payment-method',
  MENU_PREFS: 'menu-preferences',
  SUB_STATUS: 'status',
};
export const RailsCookies = {
  REMEMBER_USER_TOKEN: 'remember_user_token',
  SESSION_ID: 'session_id',
  USER_ID: 'userId',
};

export const PasswordValidationMessages = [
  'Passwords must be at least 6 characters long',
  'Must contain at least one uppercase letter',
  'Must contain at least one number',
  'Must contain at least one symbol (@, !, #...)',
];

export const FUNNEL_STEPPER_STEPS = ['About You', 'Meals', 'Checkout'];
export const FUNNEL_PATH_NAMES = ['/get-started', '/menu', '/checkout'];

export const DESKTOP_MENU_NAV_BAR_HEIGHT = 66;
export const MOBILE_MENU_NAV_BAR_HEIGHT = 56;

export const GET_STARTED_MOBILE_IMAGE_HEIGHT = 410;

export const LocalStorageKeys = {
  SUBSCRIPTION_UUID: 'subscriptionId',
};

export const ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
export const CART_ID_COOKIE_KEY = 'cartId';
export const DISMISS_ACTIVE_SUBSCRIPTION_MODAL_COOKIE =
  'dismissActiveSubscriptionModal';
export const ID_KEY = 'id';

export const CART_ID_QUERY_PARAM_KEY = CART_ID_COOKIE_KEY;
export const REFERRAL_CODE_PARAM_KEY = 'r';
export const DISCOUNT_CODE_PARAM_KEY = 'discountCode';
export const ZIP_CODE_PARAM_KEY = 'zip';
export const USER_NAME_PARAM_KEY = 'name';
export const USER_EMAIL_PARAM_KEY = 'email';
export const SELECTED_DELIVERY_DATE_PARAM_KEY = 'selectedDeliveryDate';
export const TENANT_ELIGIBILITY_CONFIG_LOGICAL_ID_PARAM_KEY = 'catalogId';
export const TAG_ID = 'tagId';

export const GraphQLErrorCodes = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
};

export const GENERIC_ERROR_MESSAGE =
  'Something went wrong. Please try again later.';

export const HONEYBADGER_TAGS = {
  segment: 'segment',
};

// @todo would be nice if this came from cart-order GQL types
export const SUBSCRIPTION_STATUSES = {
  active: 'ACTIVE',
  canceled: 'CANCELED',
};

export const ENVIRONMENTS = {
  production: 'prod',
  staging: 'stg',
  development: 'dev',
};

/**
 * At this point we're not swithcing back to multi-size and we've defaulted to this.
 */
export const DEFAULT_MEAL_SIZE = MealSize.Standard;

export const STATE_ABBREVIATIONS = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];
/**
 * Ids by which the ff catalog service distinguishes where to create and publish kosher certified meals.
 * There's more than 1 kosher certifier, each one having their own id
 * for meal variants in ecomm-catalog-svc.
 * KOSHER_ID = tag.id
 * https://github.com/powersupplyhq/ff-catalog-service/pull/226/files#diff-30ebff13fea8d361ee1d8cb78a3571fa3fffdec4299f33cefc581959404a7d35R560-R564
 */
const STAR_K_TAG_ID = 63;
const NORTH_AMERICAN_KOSHER_ID = 64;
export const KOSHER_TAG_IDS = [STAR_K_TAG_ID, NORTH_AMERICAN_KOSHER_ID];

/**
 * Key stored in localStorage to query programs on programs confirmation page, and know if we
 * should trigger "Order Completed" analytics event on the programs confirmation page.
 * If present: trigger and delete key from localStorage
 * If not present: do nothing
 */
export const PROGRAM_CONFIRMATION_KEYS = {
  programId: 'programId',
  tenantId: 'tenantId',
};
